/* eslint-disable camelcase */
/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from 'vue'
import Router from 'vue-router'
import http from '@/utils/httpRequest'
import { isURL } from '@/utils/validate'
import store from '../store'
import { clearLoginInfo } from '@/utils'
import versionTood from '@/utils/versionUpdate'
Vue.use(Router)
// 解决路由重复跳转报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// 修改原型对象中的push函数
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('common/404'), name: '404', meta: { title: '404未找到' } },
  { path: '/login', component: _import('login/login'), name: 'login', meta: { title: '登录' } },
  { path: '/register', component: _import('login/register'), name: 'register', meta: { title: '注册' } },
  { path: '/resetpassword', component: _import('login/resetpassword'), name: 'resetpassword', meta: { title: '重置密码' } },
  { path: '/dataview', component: _import('dataview/dataview'), name: 'dataview', meta: { title: '数据大屏' } },
  // { path: '/material', component: _import('material/material'), name: 'material', meta: { title: '物料预警中心' } },
  { path: '/datamonitor', component: _import('datamonitor/datamonitor'), name: 'datamonitor', meta: { title: '数据监控中心' } },
  // isJumpTo字段确保直接访问大屏页面时，路由权限接口能正常访问
  { path: '/data-dashboard', component: _import('modules/report-center/data-dashboard'), name: 'data-dashboard', meta: { title: '数据报表大屏', isJumpTo: true } },
  { path: '/cq-dashboard', component: _import('modules/report-center/cq-dashboard/index'), name: 'cq-dashboard', meta: { title: '仓擎全景视界', isJumpTo: true } },
  { path: '/data-dashboard-warehouse', component: _import('modules/report-center/data-dashboard-warehouse'), name: 'data-dashboard-warehouse', meta: { title: '数据报表大屏（分仓）', isJumpTo: true } },
  {
    path: '/simplify-form-layout',
    component: _import('canSimplifyFormLayout/simplify-form-layout'),
    name: 'simplify-form-layout',
    meta: { title: '风险预警中心' }
  },
  // { path: '/datapersonnel', component: _import('datapersonnel/datapersonnel'), name: 'datapersonnel', meta: { title: '部门处理监控中心' } },
  { path: '/redirect:path(.*)', component: _import('common/redirect'), hidden: true, name: 'redirect', meta: { title: '跳转' } }
]

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/',
  component: () => import('@/layout/main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口整体布局' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    { path: '/home', component: _import('common/home'), name: 'home', meta: { title: '首页' } }
  ],
  beforeEnter (to, from, next) {
    let authorization = Vue.cookie.get('Authorization')
    if (!authorization || !/\S/.test(authorization)) {
      clearLoginInfo()
      next({ name: 'login' })
    }
    next()
  }
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
})

router.beforeEach((to, from, next) => {
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  versionTood.isNewVersion()
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    next()
  } else {
    http({
      url: http.adornUrl('/sys/menu/nav'),
      method: 'get',
      params: http.adornParams()
    }).then(async ({ data }) => {
      sessionStorage.setItem('authorities', JSON.stringify(data.authorities || '[]'))
      await fnAddDynamicMenuRoutes(data.menuList)
      var newMenuList = JSON.parse(JSON.stringify(data.menuList))
      clearParentList(newMenuList)
      router.options.isAddDynamicMenuRoutes = true
      sessionStorage.setItem('menuList', JSON.stringify(newMenuList || '[]'))
      // store.commit('common/updateIsHome', true)
      next({ ...to, replace: true })
    }).catch((e) => {
      console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
      router.push({ name: 'login' })
    })
  }
})
router.afterEach((to, from, next) => {
  // 在离开当前路由时保存上一个路由的路径
  store.commit('common/updatePreviousRoute', from.path)
})

// 动态便利\
function clearParentList (data) {
  data.forEach(item => {
    if (item.list && item.list.length) {
      clearParentList(item.list) // 递归调用处理子级列表
      // 检查子级列表中是否有满足条件的对象
      const hasType3 = item.list.find(subItem => subItem.type == 3)
      if (hasType3) {
        item.list = null // 如果子级列表中存在 type 为 3 的对象，则清空父元素的列表
      }
    }
    return item
  })
}

// routert
function routerHandle (menuList) {
  var route = {
    path: menuList.url,
    component: null,
    name: menuList.url,
    meta: {
      menuId: menuList.menuId,
      title: menuList.name,
      isDynamic: true,
      isTab: true,
      iframeUrl: ''
    }
  }
  // url以http[s]://开头, 通过iframe展示
  if (isURL(menuList.url)) {
    route['path'] = `i-${menuList.menuId}`
    route['name'] = `i-${menuList.menuId}`
    route['meta']['iframeUrl'] = menuList.url
  } else {
    try {
      route['component'] = _import(`modules/${menuList.url}`) || null
    } catch (e) { }
  }
  return route
}

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path && !route.meta.isJumpTo) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      if (menuList[i].url && /\S/.test(menuList[i].url) && menuList[i].type == 1) {
        menuList[i].url = menuList[i].url.replace(/^\//, '')
        var route = routerHandle(menuList[i])
        routes.push(route)
      }
      temp = temp.concat(menuList[i].list)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      var route = routerHandle(menuList[i])
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    // 添加 mainRoutes（嵌套路由）
    router.addRoute(mainRoutes)
    // 添加 404 路由
    router.addRoute({ path: '*', redirect: { name: '404' } })
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
  }
}

export default router
